import { Box } from "@mui/material";
import { motion } from "motion/react";
import svgPaths from "../Loading/svg-hkmuvmlym6";

interface AnimatedLogoLineProgressProps {
  progress: number; 
  width?: number;
  height?: number;
  baseColor?: string;
  fillColor?: string;
}

const clamp = (n: number) => Math.max(0, Math.min(100, n));

export default function AnimatedLogoLineProgress({
  progress,
  width = 224,
  height = 208,
  baseColor = "#D1D5DB",
  fillColor = "#336B87",
}: AnimatedLogoLineProgressProps) {
  const p = clamp(progress);

  // 0-50% = línea superior L->R
  // 50-100% = línea inferior R->L
  const topLineProgress = Math.min(p * 2, 100);
  const bottomLineProgress = Math.max((p - 50) * 2, 0);

  return (
    <Box
      sx={{
        width,
        height,
        display: "block",
      }}
    >
      <svg
        width="100%"
        height="100%"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 224 208"
      >
        <defs>
          {/* Clip de línea superior: izquierda a derecha */}
          <clipPath id="topLineFill">
            <motion.rect
              x="0"
              y="0"
              height="104"
              initial={{ width: 0 }}
              animate={{ width: (224 * topLineProgress) / 100 }}
              transition={{ duration: 0.06, ease: "linear" }}
            />
          </clipPath>

          {/* Clip de línea inferior: derecha a izquierda */}
          <clipPath id="bottomLineFill">
            <motion.rect
              y="104"
              height="104"
              initial={{ x: 224, width: 0 }}
              animate={{
                x: 224 - (224 * bottomLineProgress) / 100,
                width: (224 * bottomLineProgress) / 100,
              }}
              transition={{ duration: 0.06, ease: "linear" }}
            />
          </clipPath>
        </defs>

        {/* BASE GRIS */}
        <g>
          <path d={svgPaths.p39165200} fill={baseColor} />
          <path d={svgPaths.p21459100} fill={baseColor} />
          <path d={svgPaths.p1843e680} fill={baseColor} />
        </g>

        {/* RELLENO SUPERIOR */}
        <g clipPath="url(#topLineFill)">
          <path d={svgPaths.p21459100} fill={fillColor} />
          <path d={svgPaths.p39165200} fill={fillColor} />
        </g>

        {/* RELLENO INFERIOR */}
        <g clipPath="url(#bottomLineFill)">
          <path d={svgPaths.p1843e680} fill={fillColor} />
        </g>
      </svg>
    </Box>
  );
}
